import React from "react";
// import ReactTooltip from "react-tooltip";

import { Button, FormControl, Tab, Tabs } from "react-bootstrap";
import { NEW_ENTRY } from "../ds/App_Constants.js";
import {  CircleX, FileDown, LogOut } from "lucide-react";

import {
  AddIcon,
  AngleDoubleLeftIcon,
  AngleDoubleRightIcon,
  BackIcon,
  ChevronLeft,
  ChevronRight,
  Eraser,
  ExcelIcon,
  ExitIcon,
  PDFIcon,
  PlayIcon,
  RefreshIcon,
  SaveIcon,
  SearchIcon,
  SwapIcon,
  TickIcon,
  UndoAlt,
} from "../gui_components/Icons.js";

import { InputTextbox } from "../gui_components/UIComponents.js";

import { focusNextElement, isEmptyString } from "../gui_components/Util.js";

const Loader = (props) => {
  let progressText = "Loading ...";
  if (!!props.loadingText) {
    progressText = props.loadingText;
  }

  return (
    <div className="loader">
      {" "}
      <div className="loaderText">
        <span>{progressText}</span>
        <div class="spinner"></div>
      </div>
    </div>
  );
};

export class BaseNodeBar extends React.Component {
  constructor(props) {
   
    
    super(props);
    this.state = {
      nodeList: this.props.nodeList,
      key: this.props.selectedModuleKey,
    };
  }

  componentDidMount() {
    //
  }

  componentDidUpdate() {
    //
  }

  nodeOnSelect = (k) => {
    this.props.nodeOnSelect(k);
    this.setState({ key: k });
  };

  render() {

    
    return (
      <div className="module-nodeBar">
        <span className="module-node-column">
          <Tabs
            id="nodeTabs"
            activeKey={this.props.selectedModuleKey}
            variant="pills"
            onSelect={this.nodeOnSelect}
          >
            {Object.values(this.props.nodeList).map((m) => (
              <Tab eventKey={m.nodeKey} 
              // title={m.nodeCaption}
              title={
                <span style={{ display: "flex", alignItems: "center", gap: "6px",marginLeft: "2px",
    marginRight: "2px" }}>
                  {m.icon}          {/* ← icon renders here */}
                  {m.nodeCaption}
                </span>
              }
              >
                {this.props.nodeList[m.nodeKey].nodeObject}
              </Tab>
            ))}
          </Tabs>
        </span>
        {!isEmptyString(this.props.moduleStatus) && (
          <span className="module-status-column">
            {this.props.moduleStatus}
          </span>
        )}
      </div>
    );
  }
}

class BaseToolBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: this.props.pageTitle,
      isShowSaveButton: this.props.isShowSaveButton,
      isShowClearCriteriaButton: this.props.isShowClearCriteriaButton,
      isShowClearErrorButton: this.props.isShowClearErrorButton,
      isShowBackButton: this.props.isShowBackButton,
      isShowPDFButton: this.props.isShowPDFButton,
      isShowApproveButton: this.props.isShowApproveButton,
      extend_toolbar: this.props.extend_toolbar,
      moduleKeyCode: this.props.moduleKeyCode,
      isLoading: this.props.isLoading,
      isShowTitle: this.props.isShowTitle,
      isShowExitButton: this.props.isShowExitButton,
    };
  }

  componentDidMount() {
    //
  }

  componentDidUpdate() {
    //
  }

  save = (e) => {
    if (e.detail === 1) this.props.save();
  };
  clearError = (e) => {
    if (e.detail === 1) this.props.clearError();
  };
  clearCriteria = (e) => {
    if (e.detail === 1) this.props.clearCriteria();
  };
  back = (e) => {
    if (e.detail === 1) this.props.back();
  };
  onModuleExit = (e) => {
    if (e.detail === 1) this.props.onModuleExit();
  };
  generatePDF = (e) => {
    if (e.detail === 1) this.props.generatePDF();
  };

  onModuleKeyCodeChange = (e) => {
    e.persist();
    this.props.onModuleKeyCodeChange(e);
  };

  onModuleKeyContainerButtonClick = () => {
    let moduleKeyCode = this.props.moduleKeyCode;
    if (moduleKeyCode == "") {
      return;
    }
    this.props.onModuleKeyContainerButtonClick(moduleKeyCode);
  };

  handleKeyDown = (event) => {
    if (event.keyCode == 13) {
      // focusNextElement();
    }
  };

  render() {
    let pageTitle = this.props.pageTitle;
    return (
      <div>
        {/* parent header */}
        <div className="module_merged_header module_merged_header2">
          {this.state.isShowTitle == true ? (
            <div className="module_header_title">{pageTitle}</div>
          ) : (
            <div className="module_header_title"></div>
          )}
          <div className="module_header_buttons">
            {/* set other module tool bars [toolbar is null does not set]  */}
            {this.props.extend_toolbar}
            {this.props.isShowSaveButton && !this.props.isSpecialViewMode && (
              <Button
                className="header_buttons btn-flx"
                size="sm"
                onClick={(e) => this.save(e)}
              >
                <SaveIcon /> Save{" "}
              </Button>
            )}
            {this.props.isShowClearCriteriaButton &&
              !this.props.isSpecialViewMode && (
                <Button
                  className="header_buttons btn-flx"
                  size="sm"
                  onClick={(e) => this.clearCriteria(e)}
                >
                  <Eraser size={16} />
                  Clear{" "}
                </Button>
              )}
            {this.props.isShowClearErrorButton &&
              !this.props.isSpecialViewMode && (
                <Button
                  className="header_buttons btn-flx"
                  size="sm"
                  onClick={(e) => this.clearError(e)}
                >
                 <CircleX size={16} />
                  Clear Error{" "}
                </Button>
              )}
            {this.props.isShowBackButton && (
              <Button
                className="header_buttons secondary btn-flx"
                size="sm"
                onClick={(e) => this.back(e)}
              >
                <BackIcon />
                Back{" "}
              </Button>
            )}

            {this.props.isShowPDFButton && !this.props.isSpecialViewMode && (
              <Button
                className="header_buttons secondary btn-flx"
                size="sm"
                onClick={(e) => this.generatePDF(e)}
              >
                <FileDown size={16} />
                PDF
              </Button>
            )}
            {this.props.isShowExitButton && (
              <Button
                className="header_buttons btn-flx"
                size="sm"
                onClick={(e) => this.onModuleExit(e)}
              >
                <LogOut size={16} />
                Exit
              </Button>
            )}
          </div>
        </div>
      </div>
    );
  }
}

class BaseToolBar_bkup_21Sep2021 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: this.props.pageTitle,
      isShowSaveButton: this.props.isShowSaveButton,
      isShowClearCriteriaButton: this.props.isShowClearCriteriaButton,
      isShowClearErrorButton: this.props.isShowClearErrorButton,
      isShowBackButton: this.props.isShowBackButton,
      isShowPDFButton: this.props.isShowPDFButton,
      isShowApproveButton: this.props.isShowApproveButton,
      extend_toolbar: this.props.extend_toolbar,
      moduleKeyCode: this.props.moduleKeyCode,
      isLoading: this.props.isLoading,
    };
  }

  componentDidMount() {
    //
  }

  componentDidUpdate() {
    //
  }

  save = () => {
    this.props.save();
  };
  clearError = () => {
    this.props.clearError();
  };
  clearCriteria = () => {
    this.props.clearCriteria();
  };
  back = () => {
    this.props.back();
  };

  generatePDF = () => {
    this.props.generatePDF();
  };

  onModuleKeyCodeChange = (e) => {
    e.persist();
    this.props.onModuleKeyCodeChange(e);
  };

  onModuleKeyContainerButtonClick = () => {
    let moduleKeyCode = this.props.moduleKeyCode;
    if (moduleKeyCode == "") {
      return;
    }
    this.props.onModuleKeyContainerButtonClick(moduleKeyCode);
  };

  handleKeyDown = (event) => {
    if (event.keyCode == 13) {
      focusNextElement();
    }
  };

  render() {
    let pageTitle = this.props.pageTitle;
    return (
      <div>
        {/* parent header */}
        <div className="module_merged_header module_merged_header2">
          {this.props.isLoading ? <Loader /> : null}
          {/*
                    <div className="module_header_title">{pageTitle}</div>

          {this.props.isShowModuleSearchContainer && (
            <span className="moduleKeySearchContainer">
              <span>
                <FormControl
                  className="col-sm-12"
                  type="text"
                  name="moduleKeyCode"
                  value={this.props.moduleKeyCode}
                  onChange={this.onModuleKeyCodeChange}
                  onKeyDown={this.handleKeyDown}
                />
              </span>
              <span>
                <Button
                  className="header_buttons enterFocus"
                  size="sm"
                  onClick={() => this.onModuleKeyContainerButtonClick()}
                >
                  <SearchIcon />
                </Button>
              </span>
            </span>
          )} */}

          <div className="module_header_buttons">
            {/* set other module tool bars [toolbar is null does not set]  */}
            {this.props.extend_toolbar}

            {this.props.isShowSaveButton && (
              <Button
                className="header_buttons btn-flx"
                size="sm"
                onClick={() => this.save()}
              >
                <SaveIcon /> Save{" "}
              </Button>
            )}
            {this.props.isShowClearCriteriaButton && (
              <Button
                className="header_buttons btn-flx"
                size="sm"
                onClick={() => this.clearCriteria()}
              >
                {" "}
                Clear{" "}
              </Button>
            )}
            {this.props.isShowClearErrorButton && (
              <Button
                className="header_buttons btn-flx"
                size="sm"
                onClick={() => this.clearError()}
              >
                {" "}
                Clear Error{" "}
              </Button>
            )}
            {this.props.isShowBackButton && (
              <Button
                className="header_buttons btn-flx"
                size="sm"
                onClick={() => this.back()}
              >
                <BackIcon />
                Back{" "}
              </Button>
            )}

            {this.props.isShowPDFButton && (
              <Button
                className="header_buttons btn-flx"
                size="sm"
                onClick={() => this.generatePDF()}
              >
                PDF
              </Button>
            )}
          </div>
        </div>

        {/* <Table striped bordered hover  >
					<thead>
						<tr>
		<th aria-colspan="9"   > {pageTitle}</th>
							{this.props.isShowSaveButton && <th><Button size="sm" onClick={() => this.save()}> Save </Button></th>}
							{this.props.isShowClearCriteriaButton && <th><Button size="sm" onClick={() => this.clearCriteria()}> Clear  </Button></th>}
							{this.props.isShowClearErrorButton && <th><Button size="sm" onClick={() => this.clearError()}> Clear Error </Button></th>}
							{this.props.isShowBackButton && <th><Button size="sm" onClick={() => this.back()}> Back </Button></th>}
						</tr>
					</thead>
				</Table> */}
      </div>
    );
  }

  render_bkup_20Sep2021() {
    let pageTitle = this.props.pageTitle;
    return (
      <div>
        {/* parent header */}
        <div className="module_merged_header module_merged_header2">
          {/* <div className="module_header_title">{pageTitle}</div>
          {this.props.isLoading ? <Loader /> : null}
          {this.props.isShowModuleSearchContainer && (
            <span className="moduleKeySearchContainer">
              <span>
                <FormControl
                  className="col-sm-12"
                  type="text"
                  name="moduleKeyCode"
                  value={this.props.moduleKeyCode}
                  onChange={this.onModuleKeyCodeChange}
                  onKeyDown={this.handleKeyDown}
                />
              </span>
              <span>
                <Button
                  className="header_buttons enterFocus"
                  size="sm"
                  onClick={() => this.onModuleKeyContainerButtonClick()}
                >
                  <SearchIcon />
                </Button>
              </span>
            </span>
          )} */}

          <div className="module_header_buttons">
            {/* set other module tool bars [toolbar is null does not set]  */}
            {this.props.extend_toolbar}

            {this.props.isShowSaveButton && (
              <Button
                className="header_buttons"
                size="sm"
                onClick={() => this.save()}
              >
                <SaveIcon /> Save{" "}
              </Button>
            )}
            {this.props.isShowClearCriteriaButton && (
              <Button
                className="header_buttons"
                size="sm"
                onClick={() => this.clearCriteria()}
              >
                {" "}
                Clear{" "}
              </Button>
            )}
            {this.props.isShowClearErrorButton && (
              <Button
                className="header_buttons"
                size="sm"
                onClick={() => this.clearError()}
              >
                {" "}
                Clear Error{" "}
              </Button>
            )}
            {this.props.isShowBackButton && (
              <Button
                className="header_buttons"
                size="sm"
                onClick={() => this.back()}
              >
                <BackIcon />
                Back{" "}
              </Button>
            )}

            {this.props.isShowPDFButton && (
              <Button
                className="header_buttons"
                size="sm"
                onClick={() => this.generatePDF()}
              >
                PDF
              </Button>
            )}
          </div>
        </div>

        {/* <Table striped bordered hover  >
					<thead>
						<tr>
		<th aria-colspan="9"   > {pageTitle}</th>
							{this.props.isShowSaveButton && <th><Button size="sm" onClick={() => this.save()}> Save </Button></th>}
							{this.props.isShowClearCriteriaButton && <th><Button size="sm" onClick={() => this.clearCriteria()}> Clear  </Button></th>}
							{this.props.isShowClearErrorButton && <th><Button size="sm" onClick={() => this.clearError()}> Clear Error </Button></th>}
							{this.props.isShowBackButton && <th><Button size="sm" onClick={() => this.back()}> Back </Button></th>}
						</tr>
					</thead>
				</Table> */}
      </div>
    );
  }
}

class ModuleToolBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: this.props.pageTitle,
      moduleKeyCode: this.props.moduleKeyCode,
      isShowNewButton: this.props.isShowSaveButton,
      isLoading: this.props.isLoading,
      isMaintenanceMode: this.props.isMaintenanceMode,
      isResetView: this.props.isResetView,
      isShowBlur: true,
    };

    this.inputTextBoxRef = React.createRef();
  }

  componentDidMount() {
    //
    // this.inputTextBoxRef.current.focus();
    this.setFocus();
  }

  componentDidUpdate() {
    // this.setFocus();
  }
  //
  setFocus = () => {
    if (
      this.inputTextBoxRef.current != null //&&
      //this.props.isFocusLookup == true
    )
      this.inputTextBoxRef.current.focus();
    // event.preventDefault();
  };
  resetView = (e) => {
    if (e.detail === 1) {
      this.props.resetView();
      this.setFocus();
      this.state.isShowBlur = true;
    }
    // this.inputTextBoxRef.current.focus();
  };

  newEntry = (e) => {
    if (e.detail === 1) {
      this.props.onNewEntry();
      this.setFocus();
    }
  };

  getModuleListView = (e) => {
    if (e.detail === 1) this.props.getModuleListView();
    this.state.isShowBlur = true;
  };
  moduleExit = (e) => {
    if (e.detail === 1) this.props.onModuleExit();
  };

  onModuleKeyCodeChange = (e) => {
    this.props.onModuleKeyCodeChange(e);
  };

  onModuleKeyContainerButtonClick = () => {
    let moduleKeyCode = this.props.moduleKeyCode;
    if (moduleKeyCode == "") {
      return;
    }
    this.props.onModuleKeyContainerButtonClick(moduleKeyCode);
  };

  onModuleKeyCodeWithCriteriaOnChange = (e) => {
    this.props.onModuleKeyCodeWithCriteriaOnChange(e);
  };

  enterKeyEventHandler = (e) => {
    if (this.state.isShowBlur) {
      this.selectButtonClick(e);
    }
  };

  onValueChangeOnBlur = (e) => {
    if (this.state.isShowBlur) {
      e.detail = 0;
      this.selectButtonClick(e);
    }
  };

  selectButtonClick = (e) => {
    if (e.detail <= 1) {
      if (
        !isEmptyString(this.props.moduleKeyCode) &&
        this.props.moduleKeyCode != NEW_ENTRY
      ) {
        if (this.props.selectButtonClick && this.state.isShowBlur) {
          this.props.selectButtonClick(e);
          this.state.isShowBlur = false;
        }
      } else {
        this.state.isShowBlur = true;
      }
      focusNextElement();
      // e.preventDefault();
    }
  };

  render() {
    let pageTitle = this.props.pageTitle;
    return (
      <div>
        {/* parent header */}
        <div className="module_merged_header">
          <div className="title-wrapper">
            <div className="module_header_title">{pageTitle}</div>
            {this.props.lookupRequired &&
              this.props.lookupHandler != null &&
              this.props.isShowModuleSearchContainer && (
                <span className="moduleKeySearchContainer">
                  <InputTextbox
                    name="moduleKeyCode"
                    ref={this.inputTextBoxRef}
                    value={this.props.moduleKeyCode}
                    lookupRequired={true}
                    lookupHandler={this.props.lookupHandler}
                    showCriteriaDialog={true}
                    onChange={this.onModuleKeyCodeWithCriteriaOnChange}
                    // onChange={this.onModuleKeyCodeChange}
                    // isFocusLookup={this.props.isFocusLookup}
                    disabled={this.props.disabled}
                    enterKeyEventHandler={this.enterKeyEventHandler}
                    valueChangeOnBlur={this.state.isShowBlur}
                    onValueChangeOnBlur={this.onValueChangeOnBlur}
                  />
                  <Button
                    className="selectButton"
                    size="sm"
                    onClick={(e) => this.selectButtonClick(e)}
                    disabled={this.props.disabled}
                  >
                    <TickIcon />
                  </Button>
                </span>
              )}
          </div>

          {this.props.isLoading ? (
            <Loader loadingText={this.props.loadingText} />
          ) : null}

          {/* {this.props.lookupRequired &&
            this.props.lookupHandler != null &&
            this.props.isShowModuleSearchContainer && (
              <span className="moduleKeySearchContainer">
                <InputTextbox
                  name="moduleKeyCode"
                  ref={this.inputTextBoxRef}
                  value={this.props.moduleKeyCode}
                  lookupRequired={true}
                  lookupHandler={this.props.lookupHandler}
                  //selectButtonClick={this.props.selectButtonClick}
                  showCriteriaDialog={true}
                  onChange={this.onModuleKeyCodeWithCriteriaOnChange}
                  // onChange={this.onModuleKeyCodeChange}
                  // isFocusLookup={this.props.isFocusLookup}
                  disabled={this.props.disabled}
                  enterKeyEventHandler={this.enterKeyEventHandler}
                  onValueChangeOnBlur={this.onValueChangeOnBlur}
                />
                <Button
                  className="selectButton"
                  size="sm"
                  onClick={() => this.selectButtonClick()}
                  disabled={this.props.disabled}
                >
                  <TickIcon />
                </Button>
              </span>
            )} */}

          {/* {this.props.isShowModuleSearchContainer && (
            <span className="moduleKeySearchContainer">
              <span>
                <FormControl
                  className="col-sm-12"
                  type="text"
                  name="moduleKeyCode"
                  value={this.props.moduleKeyCode}
                  onChange={this.onModuleKeyCodeChange}
                  onKeyDown={this.handleKeyDown}
                />
              </span>
              <span>
                <Button
                  className="header_buttons enterFocus"
                  size="sm"
                  onClick={() => this.onModuleKeyContainerButtonClick()}
                >
                  <SearchIcon />
                </Button>
              </span>
            </span>
          )} */}

          {/* {this.props.lookupRequired && this.props.lookupHandler != null ? (
            <span className="moduleKeySearchContainer">
              <InputTextbox
                ref={this.inputTextBoxRef}
                name="moduleKeyCode"
                value={this.props.moduleKeyCode}
                lookupRequired={true}
                lookupHandler={this.props.lookupHandler}
                showCriteriaDialog={true}
                onChange={this.onModuleKeyCodeWithCriteriaOnChange}
              />
            </span>
          ) : (
            
          )} */}

          {/* {this.props.isShowModuleSearchContainer && (
            <span className="moduleKeySearchContainer">
              <span>
                <FormControl
                  className="col-sm-12"
                  type="text"
                  name="moduleKeyCode"
                  value={this.props.moduleKeyCode}
                  onChange={this.onModuleKeyCodeChange}
                  onKeyDown={this.handleKeyDown}
                />
              </span>
              <span>
                <Button
                  className="header_buttons enterFocus"
                  size="sm"
                  onClick={() => this.onModuleKeyContainerButtonClick()}
                >
                  <SearchIcon />
                </Button>
              </span>
            </span>
          )}

          {this.props.lookupRequired && (
            <InputTextbox
              ref={this.inputTextBoxRef}
              name="moduleKeyCode"
              value={this.props.moduleKeyCode}
              lookupRequired={true}
              lookupHandler={this.props.lookupHandler}
              showCriteriaDialog={true}
            />
          )} */}
          <div className="module_header_buttons">
            {this.props.isResetView && (
              <Button
                className="header_buttons btn-flx"
                size="sm"
                onClick={(e) => this.resetView(e)}
              >
                <RefreshIcon />
                Reset{" "}
              </Button>
            )}
            {this.props.isMaintenanceMode && (
              <Button
                className="header_buttons btn-flx"
                size="sm"
                onClick={(e) => this.getModuleListView(e)}
              >
                <SwapIcon />
                List View{" "}
              </Button>
            )}
            {!this.props.isMaintenanceMode && !this.props.isSpecialViewMode && (
              <Button
                className="header_buttons"
                size="sm"
                onClick={(e) => this.newEntry(e)}
              >
                <SwapIcon /> Maint{" "}
              </Button>
            )}
            {this.props.isShowNewButton && (
              <Button
                className="header_buttons btn-flx"
                size="sm"
                onClick={(e) => this.newEntry(e)}
              >
                <SwapIcon /> New{" "}
              </Button>
            )}
            <Button
              className="header_buttons btn-flx"
              size="sm"
              onClick={(e) => this.moduleExit(e)}
            >
              <ExitIcon /> Exit{" "}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

// class ModuleToolBar_withIcon extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       pageTitle: this.props.pageTitle,
//       moduleKeyCode: this.props.moduleKeyCode,
//       isShowNewButton: this.props.isShowSaveButton,
//       isLoading: this.props.isLoading,
//       isMaintenanceMode: this.props.isMaintenanceMode,
//       isResetView: this.props.isResetView,
//     };

//     this.inputTextBoxRef = React.createRef();
//   }

//   componentDidMount() {
//     //
//     // this.inputTextBoxRef.current.focus();
//     this.setFocus();
//   }

//   componentDidUpdate() {
//     // this.setFocus();
//   }
//   //
//   setFocus = () => {
//     if (
//       this.inputTextBoxRef.current != null //&&
//       //this.props.isFocusLookup == true
//     )
//       this.inputTextBoxRef.current.focus();
//     // event.preventDefault();
//   };
//   resetView = (e) => {
//     if (e.detail === 1) {
//       this.props.resetView();
//       this.setFocus();
//     }
//     // this.inputTextBoxRef.current.focus();
//   };

//   newEntry = (e) => {
//     if (e.detail === 1) {
//       this.props.onNewEntry();
//       this.setFocus();
//     }
//   };

//   getModuleListView = (e) => {
//     if (e.detail === 1) this.props.getModuleListView();
//   };
//   moduleExit = (e) => {
//     if (e.detail === 1) this.props.onModuleExit();
//   };

//   onModuleKeyCodeChange = (e) => {
//     // e.persist();

//     this.props.onModuleKeyCodeChange(e);
//   };

//   onModuleKeyContainerButtonClick = () => {
//     let moduleKeyCode = this.props.moduleKeyCode;
//     if (moduleKeyCode == "") {
//       return;
//     }
//     this.props.onModuleKeyContainerButtonClick(moduleKeyCode);
//   };

//   enterKeyEventHandler = (event) => {
//     if (this.props.selectButtonClick) this.props.selectButtonClick(null);
//     focusNextElement();
//     event.preventDefault();
//   };
//   onValueChangeOnBlur = () => {};
//   onModuleKeyCodeWithCriteriaOnChange = (e) => {
//     this.props.onModuleKeyCodeWithCriteriaOnChange(e);
//   };
//   selectButtonClick = (e) => {
//     if (e.detail === 1) {
//       if (this.props.selectButtonClick) this.props.selectButtonClick(e);
//     }
//   };
//   pdfHandler = (e) => {
//     if (e.detail === 1) {
//       if (this.props.pdfHandler) this.props.pdfHandler(e);
//     }
//   };
//   excelHandler = (e) => {
//     if (e.detail === 1) {
//       if (this.props.excelHandler) this.props.excelHandler(e);
//     }
//   };
//   clearErrorHandler = (e) => {
//     if (e.detail === 1) {
//       if (this.props.clearErrorHandler) this.props.clearErrorHandler(e);
//     }
//   };
//   saveHandler = (e) => {
//     if (e.detail === 1) {
//       if (this.props.saveHandler) this.props.saveHandler(e);
//     }
//   };
//   render() {
//     let pageTitle = this.props.pageTitle;

//     return (
//       <div>
//         {/* parent header */}
//         <div className="module_merged_header">
//           <div className="title-wrapper">
//             <div className="module_header_title">{pageTitle}</div>
//             {this.props.lookupRequired &&
//               this.props.lookupHandler != null &&
//               this.props.isShowModuleSearchContainer && (
//                 <span className="moduleKeySearchContainer">
//                   <InputTextbox
//                     name="moduleKeyCode"
//                     ref={this.inputTextBoxRef}
//                     value={this.props.moduleKeyCode}
//                     lookupRequired={true}
//                     lookupHandler={this.props.lookupHandler}
//                     //selectButtonClick={this.props.selectButtonClick}
//                     showCriteriaDialog={true}
//                     onChange={this.onModuleKeyCodeWithCriteriaOnChange}
//                     // onChange={this.onModuleKeyCodeChange}
//                     // isFocusLookup={this.props.isFocusLookup}
//                     disabled={this.props.disabled}
//                     enterKeyEventHandler={this.enterKeyEventHandler}
//                     onValueChangeOnBlur={this.onValueChangeOnBlur}
//                   />
//                   <Button
//                     className="selectButton"
//                     size="sm"
//                     onClick={(e) => this.selectButtonClick(e)}
//                     disabled={this.props.disabled}
//                   >
//                     <TickIcon />
//                   </Button>
//                 </span>
//               )}
//           </div>

//           {this.props.isLoading ? (
//             <Loader loadingText={this.props.loadingText} />
//           ) : null}

//           {/* {this.props.lookupRequired &&
//             this.props.lookupHandler != null &&
//             this.props.isShowModuleSearchContainer && (
//               <span className="moduleKeySearchContainer">
//                 <InputTextbox
//                   name="moduleKeyCode"
//                   ref={this.inputTextBoxRef}
//                   value={this.props.moduleKeyCode}
//                   lookupRequired={true}
//                   lookupHandler={this.props.lookupHandler}
//                   //selectButtonClick={this.props.selectButtonClick}
//                   showCriteriaDialog={true}
//                   onChange={this.onModuleKeyCodeWithCriteriaOnChange}
//                   // onChange={this.onModuleKeyCodeChange}
//                   // isFocusLookup={this.props.isFocusLookup}
//                   disabled={this.props.disabled}
//                   enterKeyEventHandler={this.enterKeyEventHandler}
//                   onValueChangeOnBlur={this.onValueChangeOnBlur}
//                 />
//                 <Button
//                   className="selectButton"
//                   size="sm"
//                   onClick={() => this.selectButtonClick()}
//                   disabled={this.props.disabled}
//                 >
//                   <TickIcon />
//                 </Button>
//               </span>
//             )} */}

//           {/* {this.props.isShowModuleSearchContainer && (
//             <span className="moduleKeySearchContainer">
//               <span>
//                 <FormControl
//                   className="col-sm-12"
//                   type="text"
//                   name="moduleKeyCode"
//                   value={this.props.moduleKeyCode}
//                   onChange={this.onModuleKeyCodeChange}
//                   onKeyDown={this.handleKeyDown}
//                 />
//               </span>
//               <span>
//                 <Button
//                   className="header_buttons enterFocus"
//                   size="sm"
//                   onClick={() => this.onModuleKeyContainerButtonClick()}
//                 >
//                   <SearchIcon />
//                 </Button>
//               </span>
//             </span>
//           )} */}

//           {/* {this.props.lookupRequired && this.props.lookupHandler != null ? (
//             <span className="moduleKeySearchContainer">
//               <InputTextbox
//                 ref={this.inputTextBoxRef}
//                 name="moduleKeyCode"
//                 value={this.props.moduleKeyCode}
//                 lookupRequired={true}
//                 lookupHandler={this.props.lookupHandler}
//                 showCriteriaDialog={true}
//                 onChange={this.onModuleKeyCodeWithCriteriaOnChange}
//               />
//             </span>
//           ) : (

//           )} */}

//           {/* {this.props.isShowModuleSearchContainer && (
//             <span className="moduleKeySearchContainer">
//               <span>
//                 <FormControl
//                   className="col-sm-12"
//                   type="text"
//                   name="moduleKeyCode"
//                   value={this.props.moduleKeyCode}
//                   onChange={this.onModuleKeyCodeChange}
//                   onKeyDown={this.handleKeyDown}
//                 />
//               </span>
//               <span>
//                 <Button
//                   className="header_buttons enterFocus"
//                   size="sm"
//                   onClick={() => this.onModuleKeyContainerButtonClick()}
//                 >
//                   <SearchIcon />
//                 </Button>
//               </span>
//             </span>
//           )}

//           {this.props.lookupRequired && (
//             <InputTextbox
//               ref={this.inputTextBoxRef}
//               name="moduleKeyCode"
//               value={this.props.moduleKeyCode}
//               lookupRequired={true}
//               lookupHandler={this.props.lookupHandler}
//               showCriteriaDialog={true}
//             />
//           )} */}
//           <div className="module_header_buttons">
//             {this.props.isResetView && (
//               <div>
//                 <button
//                   className="ui-btn"
//                   data-tip="RESET"
//                   onClick={(e) => this.resetView(e)}
//                 >
//                   {/* <RefreshIcon />
//                   Reset - new */}
//                   <RESETICON />
//                 </button>
//                 <ReactTooltip
//                   place="bottom"
//                   type="dark"
//                   effect="solid"
//                   className="cstm-tool-tip"
//                 />
//               </div>
//             )}
//             {this.props.isMaintenanceMode && (
//               <>
//                 <button
//                   className="ui-btn"
//                   onClick={(e) => this.getModuleListView(e)}
//                   data-tip="LIST VIEW"
//                 >
//                   <LISTICON />
//                 </button>
//                 <ReactTooltip
//                   place="bottom"
//                   type="dark"
//                   effect="solid"
//                   className="cstm-tool-tip"
//                 />
//               </>
//             )}
//             {!this.props.isMaintenanceMode && !this.props.isSpecialViewMode && (
//               <>
//                 <button
//                   className="ui-btn"
//                   onClick={(e) => this.newEntry(e)}
//                   data-tip="NEW"
//                 >
//                   <NEWENTRYICON />
//                 </button>
//                 <ReactTooltip
//                   place="bottom"
//                   type="dark"
//                   effect="solid"
//                   className="cstm-tool-tip"
//                 />
//               </>
//             )}
//             {this.props.isShowNewButton && (
//               <>
//                 <Button
//                   className="header_buttons"
//                   size="sm"
//                   onClick={(e) => this.newEntry(e)}
//                   data-tip="NEW"
//                 >
//                   <SwapIcon /> New{" "}
//                 </Button>
//                 <ReactTooltip
//                   place="bottom"
//                   type="dark"
//                   effect="solid"
//                   className="cstm-tool-tip"
//                 />
//               </>
//             )}
//             {/* {this.props.isShowPDFButton && (
//               <>
//                 <button
//                   className="ui-btn"
//                   onClick={(e) => this.pdfHandler(e)}
//                   data-tip="PDF"
//                 >
//                   <PDFIcon />
//                 </button>
//                 <ReactTooltip
//                   place="bottom"
//                   type="dark"
//                   effect="solid"
//                   className="cstm-tool-tip"
//                 />
//               </>
//             )}
//             {this.props.isShowExcelButton && (
//               <>
//                 <button
//                   className="ui-btn"
//                   onClick={(e) => this.excelHandler(e)}
//                   data-tip="EXCEL"
//                 >
//                   <EXCELICON />
//                 </button>
//                 <ReactTooltip
//                   place="bottom"
//                   type="dark"
//                   effect="solid"
//                   className="cstm-tool-tip"
//                 />
//               </>
//             )} */}
//             {/* {this.props.isShowClearErrorButton && (
//               <>
//                 <button
//                   className="ui-btn"
//                   onClick={(e) => this.clearErrorHandler(e)}
//                   data-tip="CLEAR"
//                 >
//                   <CLEARICON />
//                 </button>
//                 <ReactTooltip
//                   place="bottom"
//                   type="dark"
//                   effect="solid"
//                   className="cstm-tool-tip"
//                 />
//               </>
//             )} */}
//             {/* {this.props.isShowSaveButton && ( */}
//             {/* <> */}
//             <button
//               className="ui-btn purple"
//               onClick={(e) => this.saveHandler(e)}
//               data-tip="SAVE"
//             >
//               <SAVEICON />
//             </button>
//             {/* <ReactTooltip
//                   place="bottom"
//                   type="dark"
//                   effect="solid"
//                   className="cstm-tool-tip"
//                 />
//               </> */}
//             {/* )} */}
//             <button
//               className="ui-btn"
//               onClick={(e) => this.moduleExit(e)}
//               data-tip="EXIT"
//             >
//               <EXITICON />
//             </button>
//             {/* <button
//               className="ui-btn"
//               onClick={(e) => this.moduleExit(e)}
//               data-tip="APPROVE"
//             >
//               <APPROVEICON />
//             </button>
//             <button
//               className="ui-btn"
//               onClick={(e) => this.moduleExit(e)}
//               data-tip="UNAPPROVE"
//             >
//               <UNAPPROVEICON />
//             </button>
//             <button
//               className="ui-btn"
//               onClick={(e) => this.moduleExit(e)}
//               data-tip="CANCEL"
//             >
//               <CANCELICON />
//             </button>
//             <button
//               className="ui-btn"
//               onClick={(e) => this.moduleExit(e)}
//               data-tip="MAIL"
//             >
//               <MAILICON />
//             </button> */}
//           </div>
//         </div>
//         <ReactTooltip
//           place="bottom"
//           type="dark"
//           effect="solid"
//           className="cstm-tool-tip"
//         />
//       </div>
//     );
//   }
// }

class ModuleToolBar_bkup_20Sep2021 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: this.props.pageTitle,
      moduleKeyCode: this.props.moduleKeyCode,
      isShowNewButton: this.props.isShowSaveButton,
      isLoading: this.props.isLoading,
      isMaintenanceMode: this.props.isMaintenanceMode,
      isResetView: this.props.isResetView,
    };

    this.inputTextBoxRef = React.createRef();
  }

  componentDidMount() {
    //
  }

  componentDidUpdate() {
    //
  }
  resetView = () => {
    this.props.resetView();
  };

  newEntry = () => {
    this.props.onNewEntry();
  };

  getModuleListView = () => {
    this.props.getModuleListView();
  };
  moduleExit = () => {
    this.props.onModuleExit();
  };

  onModuleKeyCodeChange = (e) => {
    e.persist();
    this.props.onModuleKeyCodeChange(e);
  };

  onModuleKeyContainerButtonClick = () => {
    let moduleKeyCode = this.props.moduleKeyCode;
    if (moduleKeyCode == "") {
      return;
    }
    this.props.onModuleKeyContainerButtonClick(moduleKeyCode);
  };

  handleKeyDown = (event) => {
    if (event.keyCode == 13) {
      focusNextElement();
    }
  };

  onModuleKeyCodeWithCriteriaOnChange = (e) => {
    this.props.onModuleKeyCodeWithCriteriaOnChange(e);
  };

  render() {
    let pageTitle = this.props.pageTitle;

    return (
      <div>
        {/* parent header */}
        <div className="module_merged_header">
          <div className="module_header_title">{pageTitle}</div>
          {this.props.isLoading ? (
            <Loader loadingText={this.props.loadingText} />
          ) : null}

          {this.props.lookupRequired && this.props.lookupHandler != null ? (
            <span className="moduleKeySearchContainer">
              <InputTextbox
                ref={this.inputTextBoxRef}
                name="moduleKeyCode"
                value={this.props.moduleKeyCode}
                lookupRequired={true}
                lookupHandler={this.props.lookupHandler}
                showCriteriaDialog={true}
                onChange={this.onModuleKeyCodeWithCriteriaOnChange}
              />
            </span>
          ) : (
            <span className="moduleKeySearchContainer">
              <span>
                <FormControl
                  className="col-sm-12"
                  type="text"
                  name="moduleKeyCode"
                  value={this.props.moduleKeyCode}
                  onChange={this.onModuleKeyCodeChange}
                  onKeyDown={this.handleKeyDown}
                />
              </span>
              <span>
                <Button
                  className="header_buttons enterFocus"
                  size="sm"
                  onClick={() => this.onModuleKeyContainerButtonClick()}
                >
                  <SearchIcon />
                </Button>
              </span>
            </span>
          )}

          {/* {this.props.isShowModuleSearchContainer && (
            <span className="moduleKeySearchContainer">
              <span>
                <FormControl
                  className="col-sm-12"
                  type="text"
                  name="moduleKeyCode"
                  value={this.props.moduleKeyCode}
                  onChange={this.onModuleKeyCodeChange}
                  onKeyDown={this.handleKeyDown}
                />
              </span>
              <span>
                <Button
                  className="header_buttons enterFocus"
                  size="sm"
                  onClick={() => this.onModuleKeyContainerButtonClick()}
                >
                  <SearchIcon />
                </Button>
              </span>
            </span>
          )}

          {this.props.lookupRequired && (
            <InputTextbox
              ref={this.inputTextBoxRef}
              name="moduleKeyCode"
              value={this.props.moduleKeyCode}
              lookupRequired={true}
              lookupHandler={this.props.lookupHandler}
              showCriteriaDialog={true}
            />
          )} */}
          <div className="module_header_buttons">
            <Button
              className="header_buttons"
              size="sm"
              onClick={() => this.resetView()}
            >
              <RefreshIcon />
              Reset{" "}
            </Button>

            {this.props.isMaintenanceMode && (
              <Button
                className="header_buttons"
                size="sm"
                onClick={() => this.getModuleListView()}
              >
                <SwapIcon />
                List View{" "}
              </Button>
            )}

            {!this.props.isMaintenanceMode && (
              <Button
                className="header_buttons"
                size="sm"
                onClick={() => this.newEntry()}
              >
                <SwapIcon /> Maint{" "}
              </Button>
            )}

            {this.props.isShowNewButton && (
              <Button
                className="header_buttons"
                size="sm"
                onClick={() => this.newEntry()}
              >
                <SwapIcon /> New{" "}
              </Button>
            )}

            <Button
              className="header_buttons"
              size="sm"
              onClick={() => this.moduleExit()}
            >
              <ExitIcon /> Exit{" "}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

export class AttributeModuleToolBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: this.props.pageTitle,
      moduleKeyCode: this.props.moduleKeyCode,
      isShowNewButton: this.props.isShowSaveButton,
      isLoading: this.props.isLoading,
      isMaintenanceMode: this.props.isMaintenanceMode,
      isResetView: this.props.isResetView,
    };

    this.inputTextBoxRef = React.createRef();
  }

  componentDidMount() {
    //
  }

  componentDidUpdate() {
    //
  }

  moduleExit = (e) => {
    if (e.detail === 1) this.props.onModuleExit();
  };
  newEntry = (e) => {
    if (e.detail === 1) this.props.newEntry();
  };
  resetView = (e) => {
    if (e.detail === 1) this.props.resetView();
  };

  onModuleKeyCodeChange = (e) => {
    e.persist();
    this.props.onModuleKeyCodeChange(e);
  };

  handleKeyDown = (event) => {
    if (event.keyCode == 13) {
      focusNextElement();
    }
  };

  render() {
    let pageTitle = this.props.pageTitle;

    return (
      <div>
        {/* parent header */}
        <div className="module_merged_header">
          <div className="module_header_title">{pageTitle}</div>
          {this.props.isLoading ? (
            <Loader loadingText={this.props.loadingText} />
          ) : null}

          <div className="module_header_buttons">
            {this.props.isShowRestButton && (
              <Button
                className="header_buttons btn-flx"
                size="sm"
                onClick={(e) => this.resetView(e)}
              >
                <RefreshIcon />
                Reset{" "}
              </Button>
            )}

            {this.props.isShowNewButton && (
              <Button
                className="header_buttons btn-flx"
                size="sm"
                onClick={(e) => this.newEntry(e)}
              >
                <SwapIcon /> New{" "}
              </Button>
            )}

            <Button
              className="header_buttons btn-flx"
              size="sm"
              onClick={(e) => this.moduleExit(e)}
            >
              <ExitIcon /> Exit{" "}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

class ModuleToolBar_bkup_13Sep2021 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: this.props.pageTitle,
      moduleKeyCode: this.props.moduleKeyCode,
      isShowNewButton: this.props.isShowSaveButton,
      isLoading: this.props.isLoading,
      isMaintenanceMode: this.props.isMaintenanceMode,
      isResetView: this.props.isResetView,
    };
  }

  componentDidMount() {
    //
  }

  componentDidUpdate() {
    //
  }
  resetView = () => {
    this.props.resetView();
  };

  newEntry = () => {
    this.props.onNewEntry();
  };

  getModuleListView = () => {
    this.props.getModuleListView();
  };
  moduleExit = () => {
    this.props.onModuleExit();
  };

  onModuleKeyCodeChange = (e) => {
    e.persist();
    this.props.onModuleKeyCodeChange(e);
  };

  onModuleKeyContainerButtonClick = () => {
    let moduleKeyCode = this.props.moduleKeyCode;
    if (moduleKeyCode == "") {
      return;
    }
    this.props.onModuleKeyContainerButtonClick(moduleKeyCode);
  };

  handleKeyDown = (event) => {
    if (event.keyCode == 13) {
      focusNextElement();
    }
  };

  render() {
    let pageTitle = this.props.pageTitle;

    return (
      <div>
        {/* parent header */}
        <div className="module_merged_header">
          <div className="module_header_title">{pageTitle}</div>
          {this.props.isLoading ? (
            <Loader loadingText={this.props.loadingText} />
          ) : null}
          {this.props.isShowModuleSearchContainer && (
            <span className="moduleKeySearchContainer">
              <span>
                <FormControl
                  className="col-sm-12"
                  type="text"
                  name="moduleKeyCode"
                  value={this.props.moduleKeyCode}
                  onChange={this.onModuleKeyCodeChange}
                  onKeyDown={this.handleKeyDown}
                />
              </span>
              <span>
                <Button
                  className="header_buttons enterFocus"
                  size="sm"
                  onClick={() => this.onModuleKeyContainerButtonClick()}
                >
                  <SearchIcon />
                </Button>
              </span>
            </span>
          )}
          <div className="module_header_buttons">
            <Button
              className="header_buttons"
              size="sm"
              onClick={() => this.resetView()}
            >
              <RefreshIcon />
              Reset{" "}
            </Button>

            {this.props.isMaintenanceMode && (
              <Button
                className="header_buttons"
                size="sm"
                onClick={() => this.getModuleListView()}
              >
                <SwapIcon />
                List View{" "}
              </Button>
            )}

            {!this.props.isMaintenanceMode && (
              <Button
                className="header_buttons"
                size="sm"
                onClick={() => this.newEntry()}
              >
                <SwapIcon /> Maint{" "}
              </Button>
            )}

            {this.props.isShowNewButton && (
              <Button
                className="header_buttons"
                size="sm"
                onClick={() => this.newEntry()}
              >
                <SwapIcon /> New{" "}
              </Button>
            )}

            <Button
              className="header_buttons"
              size="sm"
              onClick={() => this.moduleExit()}
            >
              <ExitIcon /> Exit{" "}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

class BaseToolBar_bkup_15Aug2021 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: this.props.pageTitle,
      isShowSaveButton: this.props.isShowSaveButton,
      isShowClearCriteriaButton: this.props.isShowClearCriteriaButton,
      isShowClearErrorButton: this.props.isShowClearErrorButton,
      isShowBackButton: this.props.isShowBackButton,
      isShowPDFButton: this.props.isShowPDFButton,
      isShowApproveButton: this.props.isShowApproveButton,
      extend_toolbar: this.props.extend_toolbar,
      moduleKeyCode: this.props.moduleKeyCode,
      isLoading: this.props.isLoading,
    };
  }

  componentDidMount() {
    //
  }

  componentDidUpdate() {
    //
  }

  save = () => {
    this.props.save();
  };
  clearError = () => {
    this.props.clearError();
  };
  clearCriteria = () => {
    this.props.clearCriteria();
  };
  back = () => {
    this.props.back();
  };

  generatePDF = () => {
    this.props.generatePDF();
  };

  onModuleKeyCodeChange = (e) => {
    e.persist();
    this.props.onModuleKeyCodeChange(e);
  };

  onModuleKeyContainerButtonClick = () => {
    let moduleKeyCode = this.props.moduleKeyCode;
    if (moduleKeyCode == "") {
      return;
    }
    this.props.onModuleKeyContainerButtonClick(moduleKeyCode);
  };

  handleKeyDown = (event) => {
    if (event.keyCode == 13) {
      focusNextElement();
    }
  };

  render() {
    let pageTitle = this.props.pageTitle;
    return (
      <div>
        {/* parent header */}
        <div className="module_header">
          <div className="module_header_title">{pageTitle}</div>
          {this.props.isLoading ? <Loader /> : null}
          {this.props.isShowModuleSearchContainer && (
            <span className="moduleKeySearchContainer">
              <span>
                <FormControl
                  className="col-sm-12"
                  type="text"
                  name="moduleKeyCode"
                  value={this.props.moduleKeyCode}
                  onChange={this.onModuleKeyCodeChange}
                  onKeyDown={this.handleKeyDown}
                />
              </span>
              <span>
                <Button
                  className="header_buttons enterFocus"
                  size="sm"
                  onClick={() => this.onModuleKeyContainerButtonClick()}
                >
                  <SearchIcon />
                </Button>
              </span>
            </span>
          )}

          <div className="module_header_buttons">
            {/* set other module tool bars [toolbar is null does not set]  */}
            {this.props.extend_toolbar}

            {this.props.isShowSaveButton && (
              <Button
                className="header_buttons"
                size="sm"
                onClick={() => this.save()}
              >
                <SaveIcon /> Save{" "}
              </Button>
            )}
            {this.props.isShowClearCriteriaButton && (
              <Button
                className="header_buttons"
                size="sm"
                onClick={() => this.clearCriteria()}
              >
                {" "}
                Clear{" "}
              </Button>
            )}
            {this.props.isShowClearErrorButton && (
              <Button
                className="header_buttons"
                size="sm"
                onClick={() => this.clearError()}
              >
                {" "}
                Clear Error{" "}
              </Button>
            )}
            {this.props.isShowBackButton && (
              <Button
                className="header_buttons"
                size="sm"
                onClick={() => this.back()}
              >
                <BackIcon />
                Back{" "}
              </Button>
            )}

            {this.props.isShowPDFButton && (
              <Button
                className="header_buttons"
                size="sm"
                onClick={() => this.generatePDF()}
              >
                PDF
              </Button>
            )}
          </div>
        </div>

        {/* <Table striped bordered hover  >
					<thead>
						<tr>
		<th aria-colspan="9"   > {pageTitle}</th>
							{this.props.isShowSaveButton && <th><Button size="sm" onClick={() => this.save()}> Save </Button></th>}
							{this.props.isShowClearCriteriaButton && <th><Button size="sm" onClick={() => this.clearCriteria()}> Clear  </Button></th>}
							{this.props.isShowClearErrorButton && <th><Button size="sm" onClick={() => this.clearError()}> Clear Error </Button></th>}
							{this.props.isShowBackButton && <th><Button size="sm" onClick={() => this.back()}> Back </Button></th>}
						</tr>
					</thead>
				</Table> */}
      </div>
    );
  }
}

class ModuleToolBar_bkup_15Aug2021 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: this.props.pageTitle,
      isShowNewButton: this.props.isShowSaveButton,
      isLoading: this.props.isLoading,
    };
  }

  componentDidMount() {
    //
  }

  componentDidUpdate() {
    //
  }

  newEntry = () => {
    this.props.onNewEntry();
  };
  moduleExit = () => {
    this.props.onModuleExit();
  };

  render() {
    let pageTitle = this.props.pageTitle;

    return (
      <div>
        {/* parent header */}
        <div className="module_header">
          <div className="module_header_title">{pageTitle}</div>
          {this.props.isLoading ? <Loader /> : null}
          <div className="module_header_buttons">
            {this.props.isShowNewButton && (
              <Button
                className="header_buttons"
                size="sm"
                onClick={() => this.newEntry()}
              >
                <AddIcon /> New{" "}
              </Button>
            )}
            <Button
              className="header_buttons"
              size="sm"
              onClick={() => this.moduleExit()}
            >
              <ExitIcon /> Exit{" "}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

class BaseNotification extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error_list: this.props.error_list,
      isShowSaveButton: this.props.isShowSaveButton,
      isShowClearCriteriaButton: this.props.isShowClearCriteriaButton,
      isShowClearErrorButton: this.props.isShowClearErrorButton,
      isShowBackButton: this.props.isShowBackButton,
    };
  }

  componentDidMount() {
    //
  }

  componentDidUpdate() {
    //
  }

  save = () => {
    this.props.save();
  };

  render() {
    let err_list = this.props.error_list;
    if (err_list == null) {
      err_list = new Array();
    }
    return (
      <div>
        {err_list.length > 0 && (
          <ul>
            {err_list.map((error) => (
              <li className="errorNotificationBar">{error}</li>
            ))}
          </ul>
        )}
      </div>
    );
  }
}
function BaseModule() {
  return (
    <div className="App">
      <header className="App-header">
        <div id="app_container"></div>
        <BaseToolBar name="" /> <br />
      </header>
    </div>
  );
}

/** Inquiry */

export class BaseInquiryToolBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: this.props.pageTitle,
      isShowAutoRefreshToggleButton: this.props.isShowAutoRefreshToggleButton,
      isShowExecuteButton: this.props.isShowExecuteButton,
      isShowClearCriteriaButton: this.props.isShowClearCriteriaButton,
      isShowClearErrorButton: this.props.isShowClearErrorButton,
      isShowResetButton: this.props.isShowResetButton,
      isShowPDFButton: this.props.isShowPDFButton,
      isShowExcelButton: this.props.isShowExcelButton,
      isShowExitButton: this.props.isShowExitButton,
      isLoading: this.props.isLoading,
      extend_toolbar: this.props.extend_toolbar,
      //changed nov 29
      isAutoRefreshing: false,
      //end
    };
  }
  componentDidMount() {
    //
  }
  componentDidUpdate() {
    //
  }
  //changed nov-29
  componentWillUnmount() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }
  //end

  // changed nov-29
  autoRefresh = (e) => {
    {
      this.setState((prevState) => {
        if (prevState.isAutoRefreshing) {
          // If refreshing is active, stop it
          clearInterval(this.intervalId);
          this.intervalId = null;
        } else {
          this.intervalId = setInterval(() => {
         
            this.props.autoRefreshExecute();
          }, 5000);
        }
        return { isAutoRefreshing: !prevState.isAutoRefreshing };
      });
    }
  };
  // end

  execute = (e) => {
    if (e.detail === 1) this.props.execute();
  };
  clearError = (e) => {
    if (e.detail === 1) this.props.clearError();
  };
  clearCriteria = (e) => {
    if (e.detail === 1) this.props.clearCriteria();
  };
  reset = (e) => {
    if (e.detail === 1) this.props.reset();
  };
  generatePDF = (e) => {
    if (e.detail === 1) this.props.generatePDF();
  };
  generateExcel = (e) => {
    if (e.detail === 1) this.props.generateExcel();
  };
  moduleExit = (e) => {
    if (e.detail === 1) this.props.onModuleExit();
  };

  render() {
    let pageTitle = this.props.pageTitle;
    //changed nov 29
    const { isAutoRefreshing } = this.state;
    //end

    return (
      <div className="module_merged_header">
        <div className="module_header_title">{pageTitle}</div>
        {this.props.isLoading ? (
          <Loader loadingText={this.props.loadingText} />
        ) : null}

        <div className="module_header_buttons">
          {this.props.extend_toolbar}
          {this.props.isShowAutoRefreshToggleButton && (
            <Button
              className="header_buttons btn-flx"
              size="sm"
              onClick={this.autoRefresh}
            >
              {""} {isAutoRefreshing ? "Auto Refresh ON" : "Auto Refresh OFF"}
            </Button>
          )}
          {this.props.isShowExecuteButton && (
            <Button
              className="header_buttons btn-flx"
              size="sm"
              onClick={(e) => this.execute(e)}
            >
              <PlayIcon />
              {""}EXEC
            </Button>
          )}
          {this.props.isShowClearCriteriaButton && (
            <Button
              className="header_buttons btn-flx"
              size="sm"
              onClick={(e) => this.clearCriteria(e)}
            >
              <Eraser />
              {""}Clear
            </Button>
          )}
          {this.props.isShowClearErrorButton && (
            <Button
              className="header_buttons btn-flx"
              size="sm"
              onClick={(e) => this.clearError(e)}
            >
              <Eraser />
              {""}ClearError
            </Button>
          )}
          {this.props.isShowResetButton && (
            <Button
              className="header_buttons btn-flx"
              size="sm"
              onClick={(e) => this.reset(e)}
            >
              <UndoAlt />
              {""}Reset
            </Button>
          )}

          {this.props.isShowPDFButton && (
            <Button
              className="header_buttons btn-flx"
              size="sm"
              onClick={(e) => this.generatePDF(e)}
            >
              <PDFIcon />
              {""}PDF
            </Button>
          )}
          {this.props.isShowExcelButton && (
            <Button
              className="header_buttons btn-flx"
              size="sm"
              onClick={(e) => this.generateExcel(e)}
            >
              <ExcelIcon />
              {""}XCEL
            </Button>
          )}
          {this.props.isShowExitButton && (
            <Button
              className="header_buttons btn-flx"
              size="sm"
              onClick={(e) => this.moduleExit(e)}
            >
              <ExitIcon /> Exit{" "}
            </Button>
          )}
        </div>
      </div>
    );
  }
}
export class BaseInquiryPageListToolBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: this.props.pageTitle,
      isLoadFirstButton: this.props.isLoadFirstButton,
      isLoadLastButton: this.props.isLoadLastButton,
      isLoadPreviousButton: this.props.isLoadPreviousButton,
      isLoadNextButton: this.props.isLoadNextButton,
    };
  }
  componentDidMount() {
    //
  }
  componentDidUpdate() {
    //
  }
  loadFirst = (e) => {
    if (e.detail === 1) this.props.loadFirst();
  };
  loadPrevious = (e) => {
    if (e.detail === 1) this.props.loadPrevious();
  };
  loadNext = (e) => {
    if (e.detail === 1) this.props.loadNext();
  };
  loadLast = (e) => {
    if (e.detail === 1) this.props.loadLast();
  };
  render() {
    return (
      <div>
        <div className="module_merged_header module_merged_header2">
          <div></div>
          <div className="module_header_buttons">
            <span className="module_pageNumber">
              PAGE - {this.props.currentPage} OF{" "}
              {parseInt(this.props.totalPages)}
            </span>
            {this.props.isLoadFirstButton && (
              <Button
                className="header_buttons btn-flx"
                size="sm"
                onClick={(e) => this.loadFirst(e)}
              >
                <AngleDoubleLeftIcon />
                First
              </Button>
            )}
            {this.props.isLoadPreviousButton && (
              <Button
                size="sm"
                className="header_buttons btn-flx"
                onClick={(e) => this.loadPrevious(e)}
              >
                <ChevronLeft />
                Previous
              </Button>
            )}
            {this.props.isLoadNextButton && (
              <Button
                size="sm"
                className="header_buttons btn-flx"
                onClick={(e) => this.loadNext(e)}
              >
                Next
                <ChevronRight />
              </Button>
            )}
            {this.props.isLoadLastButton && (
              <Button
                size="sm"
                className="header_buttons btn-flx"
                onClick={(e) => this.loadLast(e)}
              >
                Last
                <AngleDoubleRightIcon />
              </Button>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export { BaseToolBar, ModuleToolBar, BaseNotification, Loader };
